import { DeadlineContract, DeadlineContractInterval, DeadlineContractResponseSolution } from '../deadlines-contracts';
import { DeadlineViolationReason } from '../deadlines-violations-reasons';

export interface MaintenanceData {
  companyId: string;
  avatarUrl: string;
  name: string;
  status: MaintenanceStatus;
  statusInterval: MaintenanceStatusInterval;
  totalMaintenance: number;
  volumeCount: MaintenanceVolumeCount;
  ratingsCount: DashboardRatingsItem;
  averageDeadlines: DashboardMaintenancesAverageDeadlinesItem;
}

interface MaintenanceStatus {
  canceled: number;
  done: number;
  inProgress: number;
  new: number;
  pending: number;
  reported: number;
  scheduled: number;
  requested: number;
  onNegotiation: number;
}

interface MaintenanceStatusInterval {
  responseAverage: number;
  solutionAverage: number;
  pending: number;
  requested: number;
  onNegotiation: number;
  scheduled: number;
  inProgress: number;
  reported: number;
}

interface MaintenanceVolumeCount {
  acceptedCount: MaintenanceVolume;
  completedCount: MaintenanceVolume;
  incompleteCount: MaintenanceVolume;
  refusedCount: MaintenanceVolume;
  totalCount: MaintenanceVolume;
}

interface DashboardRatingsItem {
  totalCount: number;
  positiveCount: number;
  negativeCount: number;
  averageRating: number;
  oneStarCount: number;
  twoStarsCount: number;
  threeStarsCount: number;
  fourStarsCount: number;
  fiveStarsCount: number;
}

interface DashboardMaintenancesAverageDeadlinesItem {
  maintenanceCount: number;
  closedOnTimeCount: number;
  closedOutTimeCount: number;
  fistVisitOnTimeCount: number;
  fistVisitOutTimeCount: number;
  withoutDeadlineCount: number;
  averageCloseTimeInDays: number;
  closedOnTimePercentage: number;
  responseOnTimePercentage: number;
  averageResponseTimeInDays: number;
}

interface MaintenanceVolume {
  value: number;
  percent: number;
}

export enum MaintenanceDeadlineStatusEnum {
  withinDeadline = 'withinDeadline',
  atRisk = 'atRisk',
  violated = 'violated',
  completedWithViolation = 'completedWithViolation',
  completedOnTime = 'completedOnTime',
  notApplied = 'notApplied'
}

export interface MaintenanceDeadlineContract {
  name: string;
  createdAt: string;
  considerHoliday: boolean;
  hasCustomInterval: boolean;
  originalContract: Partial<DeadlineContract>;
  customInterval: DeadlineContractInterval;
  responseRisk: DeadlineContractResponseSolution;
  solutionRisk: DeadlineContractResponseSolution;
  responseDeadline: DeadlineContractResponseSolution;
  solutionDeadline: DeadlineContractResponseSolution;
  responseDeadlineViolationReason?: DeadlineContractViolationReason;
  solutionDeadlineViolationReason?: DeadlineContractViolationReason;
}

export interface DeadlineContractViolationReason {
  deadlineViolationReason: DeadlineViolationReason;
  linkedBy: 'company' | 'enterprise';
}

export enum WarrantiesStatusEnum {
  active = 'active',
  expired = 'expired',
  extended = 'extended',
  future = 'future'
}
